module.exports = __webpack_public_path__ + "static/Claudine-9db808389979709f798e97ed80c224fa.jpg";